import { useEffect, useState } from 'react';
import { liveQuery } from 'dexie';
import { db, type PedidoLocal } from './db';

/** Suscripción reactiva a los pedidos guardados en IndexedDB. */
export function useLocalOrders(): PedidoLocal[] {
  const [orders, setOrders] = useState<PedidoLocal[]>([]);

  useEffect(() => {
    const subscription = liveQuery(() =>
      db.orders.orderBy('createdAt').reverse().toArray(),
    ).subscribe({
      next: setOrders,
      error: () => setOrders([]),
    });
    return () => subscription.unsubscribe();
  }, []);

  return orders;
}
